import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ExamProvider } from './contexts/ExamContext';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ConfirmSignUp from './pages/ConfirmSignUp';
import ForgotPassword from './pages/ForgotPassword';
import UserDetails from './pages/UserDetails';
import Packages from './pages/Packages';
import Purchase from './pages/Purchase';
import PaymentSuccess from './pages/PaymentSuccess';
import Dashboard from './pages/Dashboard';
import ExamList from './pages/ExamList';
import ExamParticipation from './pages/ExamParticipation';
import ExamResults from './pages/ExamResults';
import AdminPanel from './pages/AdminPanel';
import LandingPage from './pages/LandingPage';
import ContactUs from './pages/ContactUs';
import Policies from './pages/Policies';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import './App.css';

// Wrapper component for landing page
const LandingPageWrapper = () => {
  return (
    <>
      <LandingPage />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <ExamProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/" element={<LandingPageWrapper />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/confirm-signup" element={<ConfirmSignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Navbar />
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/user-details" element={
                <ProtectedRoute>
                  <Navbar />
                  <UserDetails />
                </ProtectedRoute>
              } />
              <Route path="/packages" element={
                <ProtectedRoute>
                  <Navbar />
                  <Packages />
                </ProtectedRoute>
              } />
              <Route path="/purchase" element={
                <ProtectedRoute>
                  <Navbar />
                  <Purchase />
                </ProtectedRoute>
              } />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/exams" element={
                <ProtectedRoute>
                  <Navbar />
                  <ExamList />
                </ProtectedRoute>
              } />
              <Route path="/exam/:id" element={
                <ProtectedRoute>
                  <Navbar />
                  <ExamParticipation />
                </ProtectedRoute>
              } />
              <Route path="/exam/results/:id" element={
                <ProtectedRoute>
                  <Navbar />
                  <ExamResults />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              } />
              <Route path="/admin/blog" element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              } />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
            </Routes> 
          </div> 
        </Router>
      </ExamProvider>
    </AuthProvider>
  );
}

export default App;
